import React, { PureComponent } from 'react';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import { Redirect, Link } from 'react-router-dom';

class Navbar extends PureComponent {
  handleLogout = () => {
    sessionStorage.clear();
    localStorage.removeItem('token');
    localStorage.removeItem('userName');
    localStorage.removeItem('userId');
    localStorage.removeItem('roleId');
    this.setState({});
  }

  isAuthenticated = () => {
    const token = localStorage.getItem('token');

    return token && token.length > 10;
  }

  render() {
    const isAlreadyAuthenticated = this.isAuthenticated();

    return (
      <div>

        { !isAlreadyAuthenticated ? <Redirect to={{
          pathname: '/login'
        }} /> : (
          <div className="page">
            <div className="header">
              <div className="header__date">
                <span id="date"></span>
              </div>
              <div className="header__user">
                <DropdownButton
                  title={localStorage.getItem('userName')}
                  id="userSession"
                >
                  <MenuItem eventKey="2">
                    <Link to="/profile/password">Change password</Link>
                  </MenuItem>
                  <MenuItem divider />
                  <MenuItem eventKey="4" onClick={this.handleLogout}>Log out</MenuItem>
                </DropdownButton>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Navbar


// WEBPACK FOOTER //
// ./src/app/components/complex/navbar.js